<template>
  <div
    :class="[
      'track-group',
      {
        'track-group--selected':
          backgroundSelected || selected || externalSelected,
        'track-group--transitioning': reordering && !selected
      }
    ]"
    ref="trackGroup"
    @click="handleClick"
    @contextmenu="handleContextMenu"
    :style="usedStyle"
  >
    <div
      :class="[
        'track-group__left',
        {
          'track-group__left--move': type === 'effect'
        }
      ]"
      @mousedown="handleMouseDown"
    >
      <div
        class="track-group__label"
        :class="{ 'track-group__label--indent': type === 'audio' }"
        :title="usedLabel"
      >
        {{ usedLabel }}
      </div>

      <button
        type="button"
        class="iconfont track-group__btn track-group__btn--hide"
        v-show="hidden"
        @click="unhideEffect"
      >
        &#xe65b;
      </button>

      <button
        type="button"
        class="iconfont track-group__btn track-group__btn--lock"
        v-show="locked"
        @click="unlockEffect"
      >
        &#xe606;
      </button>

      <button
        title="重命名"
        type="button"
        class="track-group__btn track-group__btn--edit"
        v-if="type === 'effect'"
        @click="showRename"
      >
        <a-icon type="edit" />
      </button>

      <button
        type="button"
        class="track-group__btn track-group__btn--expand"
        @click="toggleExpand"
        v-if="showTracks && tracks && tracks.length > 1"
        :class="{ 'track-group__btn--expanded': expanded }"
      >
        <a-icon type="right" />
      </button>

      <button
        type="button"
        class="track-group__btn track-group__btn--expand"
        v-if="type === 'audioExpand'"
        :class="{ 'track-group__btn--expanded': audioExpanded }"
      >
        <a-icon type="right" />
      </button>

      <button
        title="编辑关联"
        type="button"
        class="track-group__btn track-group__btn--link"
        v-if="linked"
        @click="editEffectLink"
      >
        <a-icon type="link" />
      </button>
    </div>
    <div
      class="track-group__right track-group__right--background"
      v-if="type === 'background'"
    >
      <div class="track-row">
        <div
          class="track-row__body track-row__body--background"
          :style="{
            width: total * 0.1 * scale + 'px',
            transform: 'translate(' + -offset + 'px)'
          }"
        >
          <template v-if="activeFragment.backgroundType">
            <template v-if="activeFragment.backgroundType === 'image'">
              图片背景
            </template>
            <template v-else>视频背景</template>
            <el-tooltip content="清除背景">
              <a-button
                @click="unsetBackground"
                class="track-row__unset-btn"
                type="link"
              >
                <span class="el-icon-close" />
              </a-button>
            </el-tooltip>
          </template>
          <color-gradient-editor
            v-else
            hide-types
            :show-alpha="false"
            v-model="activeFragment.backgroundColor"
            label="背景"
          />
        </div>
      </div>
    </div>
    <div
      class="track-group__right track-group__right--background"
      v-else-if="type === 'audioExpand'"
    >
      <div class="track-row">
        <div
          class="track-row__body"
          :style="{
            /* width: total * 0.1 * scale + 'px',
            transform: 'translate(' + -offset + 'px)'*/
          }"
        />
      </div>
    </div>
    <div class="track-group__right" v-else>
      <div class="track-row" v-if="type === 'effect'">
        <div
          class="track-row__body"
          :style="{
            width: total * 0.1 * scale + 'px',
            transform: 'translate(' + -offset + 'px)'
          }"
        >
          <track-component
            :max="Infinity"
            :total="total"
            :track="effect"
            @change="handleEffectChange"
            @select="recordSelectEffect"
            :label="usedTrackLabel"
            :totalWidth="total * 0.1 * scale"
            :type="effect.type"
            @dragDuration="recordEffectSnap(effect)"
            @startoffset="handleStartOffset"
          />
        </div>
      </div>
      <div class="track-row" v-show="showTracks">
        <div
          class="track-row__body"
          :style="{
            width: total * 0.1 * scale + 'px',
            transform: 'translate(' + -offset + 'px)',
            height: (expanded ? expandedHeight : 30) + 'px'
          }"
        >
          <div
            v-if="!tracks || !tracks.length"
            style="
              position: absolute;
              line-height: 30px;
              top: 0;
              opacity: 0.7;
              left: 12px;
            "
          >
            当前项暂无轨迹内容。
          </div>
          <template v-if="type === 'track'">
            <track-component
              v-for="(track, i) in tracks"
              :key="track.id"
              :max="tracks[i + 1] ? tracks[i + 1].start : total"
              :min="
                tracks[i - 1] ? tracks[i - 1].start + tracks[i - 1].duration : 0
              "
              :total="total"
              :track="track"
              @select="selectTrack(track, i)"
              :selected="selectedTrackId === track.id"
              @change="handleTrackChange"
              :totalWidth="total * 0.1 * scale"
              type="track"
              :style="expanded ? { top: i * 28 + 'px' } : {}"
            />
          </template>
          <template v-else>
            <track-component
              v-for="(track, i) in tracks"
              :key="track.id"
              :max="Infinity"
              :min="0"
              :total="total"
              :track="track"
              :label="getEffectTrackLabel(track)"
              @select="selectTrack(track, i)"
              :selected="selectedTrackId === track.id"
              @change="handleTrackChange"
              :totalWidth="total * 0.1 * scale"
              :type="type === 'effect' ? effect.type : type"
              :style="expanded ? { top: i * 28 + 'px' } : {}"
              @dragDuration="recordEffectTrackSnap(track, i)"
              @startoffset="handleAudioStartOffset"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Track from './Track';
import ColorGradientEditor from '../base/ColorGradientEditor';
import { getEffectName, labelPrefixes } from '../../utils/util';
import { clamp, isMac } from '../../utils';
import { mapState } from 'vuex';

export default {
  model: {
    prop: 'tracks',
    event: 'changetracks'
  },
  data() {
    return {
      ownSelectedTrackId: -1,
      reorderOffset: 0,
      internalSelected: false,
      expanded: false
    };
  },
  components: {
    "track-component": Track,
    ColorGradientEditor
  },
  props: ["label", "total", "tracks", "scale", "offset", "type", "effect", 'audioExpanded', 'snap', 'current'],
  computed: {
    ...mapState(['selectedEffectIds']),
    allEffects() {
      return this.$store.state.effects;
    },
    activeFragment() {
      return this.$store.getters.activeFragment;
    },
    selectedEffectId() {
      return this.$store.getters.selectedEffectId;
    },
    selectedEffect: {
      get() {
        return this.$store.getters.selectedEffect;
      },
      set(value) {
        this.$store.commit('handleEffectSelect', [value.id]);
      }
    },
    backgroundSelected() {
      if (this.type === 'background') {
        return this.selectedEffectId === 'BACKGROUND_SELECT';
      }
      return false;
    },
    selected() {
      switch (this.type) {
        case 'effect':
          return this.selectedEffect === this.effect;
        case 'audio':
          return this.selectedTrackId === this.tracks[0].id;
        default:
          return false;
      }
    },
    lookup() {
      return this.$store.getters.selectionLookup;
    },
    externalSelected() {
      if (this.type === 'effect') {
        return !!this.lookup[this.effect.id];
      }
      return false;
    },
    locked() {
      if (this.type !== 'effect') {
        return false;
      }
      return this.effect.locked;
    },
    hidden() {
      if (this.type !== 'effect') {
        return false;
      }
      return this.effect.hidden;
    },
    reordering: {
      get() {
        return this.type === 'effect' && this.$store.state.effectReordering;
      },
      set(value) {
        this.$store.commit('handleEffectReorder', value);
      }
    },
    nextOrder: {
      get() {
        return this.$store.state.nextEffectOrder;
      },
      set(value) {
        this.$store.commit('handleNextEffectOrder', value);
      }
    },
    usedStyle() {
      if (this.reordering) {
        if (this.selected) {
          return {
            transform: `translateY(${this.reorderOffset}px)`
          };
        } else if (this.nextOrder) {
          console.log(this.nextOrder);
          const nextIndex = this.nextOrder.indexOf(this.effect.id);
          return {
            transform: `translateY(${(
              nextIndex > this.origEffectIndex
                ? -1
                : nextIndex === this.origEffectIndex ? 0 : 1
            ) * this.reordering.height}px)`
          };
        }
      }
      return {};
    },
    usedLabel() {
      const { shapeNames, videoSeriesTagMode, videoSeriesTagNames, effects } = this.$store.state;
      if (this.type === 'effect') {
        if (this.effect.type in labelPrefixes) {
          const effectName = this.effect.content.name;
          let usedEffectName = effectName;
          if (videoSeriesTagMode) {
            const { videoSeriesTags, videoSeriesTagParams } = this.effect;
            let usedTags = videoSeriesTags;
            let usedParams = videoSeriesTagParams;
            if (videoSeriesTagParams && videoSeriesTagParams.type === 'material') {
              const linked = effects[videoSeriesTagParams.link];
              if (linked && linked.videoSeriesTags) {
                usedTags = linked.videoSeriesTags.concat(videoSeriesTags[videoSeriesTags.length - 1]);
                usedParams = linked.videoSeriesTagParams;
              }
            }
            if (usedTags) {
              usedEffectName = usedTags.slice(1).map(t => videoSeriesTagNames[t]);
              let prefix = '公司';

              if (usedTags[0] === 2) {
                prefix = ['产品', usedParams && usedParams.type === 'product' ? +usedParams.link + 1 : '1'].join(' ');
              }
              let suffix = [];
              if (usedParams && usedParams.type === 'process') {
                suffix = usedParams.link + 1;
              }
              usedEffectName = [
                [prefix].concat(usedEffectName).join('-')
              ].concat(suffix).join(' ');
            } else {
              usedEffectName = '';
            }
          } else {
            usedEffectName = getEffectName(this.effect, shapeNames);
          }
          let prefix = labelPrefixes[this.effect.type];
          if (this.effect.type === 'lottie' && this.effect.isEffect) {
            prefix = '特效';
          }
          return `${prefix}: ${usedEffectName}`;
        }

        return 'Unknown Effect';
      }
      return this.label;
    },
    usedTrackLabel() {
      if (this.type === 'effect') {
        switch (this.effect.type) {
          case 'text':
            return `文本内容`;
          case 'video':
            return `视频内容`;
          case 'image':
            return `图片内容`;
          case 'shape':
            return '形状';
          case 'container':
          case 'textContainer':
            return '容器';
          case 'sticker':
            return '贴纸内容';
          case 'lottie':
            return '动画内容';
          case 'group':
            return '组合';
          case 'wordArt':
            return '艺术字';
          case 'icon':
            return '图标';
        }
        return 'Unknown';
      }
      return '';
    },
    // backgroundIsImage() {
    //   return !!this.activeFragment.background;
    // },
    selectedTrackId: {
      get() {
        switch (this.type) {
          case 'track':
            return this.$store.state.selectedTrackId;
          case 'audio':
            return this.$store.state.selectedAudioId;
          default:
            return this.ownSelectedTrackId;
        }
      },
      set(value) {
        switch (this.type) {
          case 'track':
            this.$store.commit('handleTrackSelect', value);
            break;
          case 'audio':
            this.$store.commit('handleAudioSelect', value);
            break;
          default:
            this.ownSelectedTrackId = value;
        }
      }
    },
    showTracks() {
      if (this.type !== 'effect') {
        return true;
      }
      if (this.effect) {
        if (this.effect.showTracks) {
          return true;
        }
      }
      return false;
    },
    expandedHeight() {
      return Math.max(30, this.tracks.length * 28 + 2);
    },
    linked() {
      const { userBasics } = this.$store.state;
      if (this.type === 'effect' && this.effect) {
        if (userBasics && userBasics.is_open_template) {
          return this.effect.linkId || this.activeFragment.nameLinks && this.activeFragment.nameLinks[this.effect.content.name];
        }
      }
      return false;
    },
    snapCurrent() {
      return Math.round(this.current / 10) * 10;
    }
  },
  methods: {
    selectEffect() {
      switch (this.type) {
        case 'effect':
          this.internalSelected = true;
          this.selectedEffect = this.effect;
          break;
        case 'audio':
          this.selectedTrackId = this.tracks[0].id;
          break;
        case 'background':
          this.$store.dispatch('selectBackground');
          break;
        case 'audioExpand':
          this.toggleAudioExpand();
          break;
      }
    },
    recordEffectSnap(ef) {
      const points = [0, this.total];
      if (this.snap) {
        const { effects, audios } = this.snap;
        effects.forEach(t => {
          if (t.id !== ef.id) {
            points.push(t.start, t.start + t.duration);
            if (t.showTracks) {
              t.tracks.forEach(r => {
                points.push(r.start, r.start + r.duration);
              });
            }
          }
        });
        audios.forEach(t => {
          points.push(t.start, t.start + t.duration);
        });
        this.snapPoints = points;
      }
    },
    recordEffectTrackSnap(track, index) {
      if (this.snap) {
        const { effects, audios } = this.snap;
        const points = [0, this.total];
        let done = false;
        switch (this.type) {
          case 'audio':
            effects.forEach(t => {
              points.push(t.start, t.start + t.duration);
              if (t.showTracks) {
                t.tracks.forEach(r => {
                  points.push(r.start, r.start + r.duration);
                });
              }
            });
            audios.forEach(t => {
              if (t.id !== track.id) {
                points.push(t.start, t.start + t.duration);
              }
            });
            done = true;
            break;
          case 'effect':
            effects.forEach(t => {
              points.push(t.start, t.start + t.duration);
              if (t.showTracks) {
                t.tracks.forEach((r, i) => {
                  if (t.id !== this.effect.id || i !== index) {
                    points.push(r.start, r.start + r.duration);
                  }
                });
              }
            });
            audios.forEach(t => {
              points.push(t.start, t.start + t.duration);
            });
            done = true;
            break;
        }
        if (done) {
          this.snapPoints = points;
        }
      }
    },
    recordSelectEffect() {
      this.selectEffect();
      const ef = this.effect;
      this.trackStarts = ef.showTracks ? ef.tracks.map(tr => {
        return tr.start - ef.start;
      }) : [];
      this.recordEffectSnap(ef);
    },
    selectTrack(track, index) {
      this.selectEffect();
      this.selectedTrackId = track.id;
      if (this.type === 'track') {
        this.$store.commit('handleCurrentProgress', track.start + this.activeFragment.start);
      } else {
        this.recordEffectTrackSnap(track, index);
      }
    },
    autoSnap(edited) {
      if (this.snapPoints) {
        // TODO: snap
        let curSnap;
        if (this.snapPoints.concat(this.snapCurrent).some(sn => {
          switch (edited.type) {
            case 'start':
              if (Math.abs(sn - edited.start) < 100 / this.scale) {
                edited.start = sn;
                curSnap = sn;
                return true;
              }
              if (Math.abs(sn - edited.start - edited.duration) < 100 / this.scale) {
                edited.start = sn - edited.duration;
                curSnap = sn;
                return true;
              }
              break;
            case 'duration':
              if (Math.abs(sn - edited.start - edited.duration) < 100 / this.scale) {
                edited.duration = Math.max(400, sn - edited.start);
                curSnap = sn;
                return true;
              }
              break;
            case 'startOnly':
              if (Math.abs(sn - edited.start) < 100 / this.scale) {
                const end = edited.start + edited.duration;
                edited.start = sn;
                edited.duration = Math.max(400, end - sn);
                curSnap = sn;
                return true;
              }
          }
          return false;
        })) {
          this.$emit('snap', curSnap);
        }
      }
    },
    handleEffectChange(edited) {
      this.autoSnap(edited);
      this.trackStarts.forEach((v, i) => {
        this.effect.tracks[i].start = Math.max(0, edited.start + v);
      });
      this.effect.start = edited.start;
      this.effect.duration = edited.duration;
    },
    handleStartOffset(orig) {
      const { content: efc, start, type, duration } = this.effect;
      const offset = start - orig;
      if (offset && type === 'video') {
        console.log('setting crop by ' + offset);
        const { crop, playbackRate } = efc;
        const actualPlaybackRate = clamp(playbackRate || 1, .1, 10);
        const cropStart = crop ? crop[0] : 0;
        const cropEnd = crop ? crop[1] : duration * actualPlaybackRate / 1e3;

        this.$set(efc, 'crop', [Math.max(0, cropStart + offset * actualPlaybackRate / 1e3), cropEnd]);
      }
    },
    handleAudioStartOffset(orig) {
      if (this.type === 'audio') {
        const track = this.tracks[0];
        const { start, duration, crop, playbackRate } = track;
        const offset = start - orig;
        const actualPlaybackRate = clamp(playbackRate || 1, .1, 10);
        const cropStart = crop ? crop[0] : 0;
        const cropEnd = crop ? crop[1] : duration * actualPlaybackRate / 1e3;

        this.$set(track, 'crop', [Math.max(0, cropStart + offset * actualPlaybackRate / 1e3), cropEnd]);
      }
    },
    handleTrackChange(edited) {
      if (this.type === 'audio' || this.type === 'effect') {
        this.autoSnap(edited);
      }
      this.$emit("changetracks", this.tracks.map(t => t.id === edited.id ? {
        ...t,
        start: edited.start,
        duration: edited.duration
      } : t));
    },
    handleMouseDown(e) {
      const isCtrl = isMac && e.metaKey || e.ctrlKey;
      if (this.type === 'effect' && !e.button) {
        if (isCtrl) {
          console.log('multiple selection');
          return;
        }
        e.stopPropagation();
        document.body.classList.add('unselectable');
        this.selectEffect();
        const height = this.$refs.trackGroup.getBoundingClientRect().height;
        this.reordering = {
          height,
          y: e.clientY
        };
      }
    },
    handleClick(e) {
      const isCtrl = isMac && e.metaKey || e.ctrlKey;
      if (isCtrl && this.type === 'effect') {
        const allIds = this.selectedEffectIds.filter(t => t !== 'BACKGROUND_SELECT');
        const effectId = this.effect.id;
        let nextIds = this.externalSelected ? allIds.filter(t => t !== effectId) : allIds.concat(effectId);
        this.$store.commit('handleEffectSelect', nextIds);

        return;
      }
      this.selectEffect();
    },
    handleMouseMove(e) {
      if (this.reordering) {
        if (this.selected) {
          this.reorderOffset = e.clientY - this.reordering.y;
        } else {
          const bcr = this.$refs.trackGroup.getBoundingClientRect();
          if (e.clientY >= bcr.top && e.clientY <= bcr.bottom) {
            console.log('dragging over: ' + this.effect.id);
            if (e.clientY < (bcr.top + bcr.bottom) / 2) {
              // above
              this.nextOrder = [].concat.apply([], this.savedEffectOrder.map(efid => {
                if (efid === this.effect.id) {
                  return [efid, this.selectedEffect.id];
                }
                return efid;
              }));
            } else {
              // below
              this.nextOrder = [].concat.apply([], this.savedEffectOrder.map(efid => {
                if (efid === this.effect.id) {
                  return [this.selectedEffect.id, efid];
                }
                return efid;
              }));
            }
          }
        }
      }
    },
    handleMouseUp() {
      if (this.reordering && this.selected) {
        // reorder ends
        // which applies to all instances, not only the executing one
        // but it needs to be executed only once, so it is written here

        this.reordering = false;
        if (this.nextOrder) {
          this.$store.dispatch('changeActiveFragment', {
            ...this.activeFragment,
            effects: this.nextOrder
          });
          this.nextOrder = null;
        }
        setTimeout(() => {
          document.body.classList.remove('unselectable');
        }, 0);
        this.reorderOffset = 0;
      }
    },
    unlockEffect() {
      this.effect.locked = false;
    },
    unhideEffect() {
      this.effect.hidden = false;
    },
    showRename() {
      let id = this.effect.id
      this.$store.dispatch('renameEffect', { effectId: id });
    },
    getEffectTrackLabel(track) {
      switch (this.type) {
        case 'effect':
          return this.$store.state.effectNames[track.effectType];
        case 'audio':
          return track.name;
        default:
          return '';
      }
    },
    handleContextMenu(e) {
      if (this.type === 'effect') {
        e.preventDefault();
        const isMultiple = this.externalSelected && !this.selected;
        if (!this.externalSelected) {
          this.selectEffect();
        }
        this.$store.dispatch('openEffectContextMenu', {
          x: e.clientX,
          y: e.clientY,
          effectId: isMultiple ? null : this.effect.id
        });
      }
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    toggleAudioExpand() {
      this.$emit('update:audioExpanded', !this.audioExpanded);
    },
    editEffectLink() {
      this.selectedEffect = this.effect;
      this.$store.commit('handleLinkMaterialVisible', true);
    },
    unsetBackground() {
      this.$store.dispatch('unsetBackground');
    }
  },
  mounted() {
    this.trackStarts = [];
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  watch: {
    selectedEffectId(val) {
      if (val && this.type === 'track') {
        this.selectedTrackId = null;
      }
    },
    selectedTrackId(val) {
      if (this.type === 'track') {
        if (val) {
          this.$store.commit('handleEffectSelect', []);
        }
        this.$store.commit('handleTrackEdit', false);
      }
    },
    selected(val) {
      if (this.type === 'effect') {
        if (!val) {
          this.selectedTrackId = -1;
          this.internalSelected = false;
        } else if (val && !this.reordering) {
          if (this.internalSelected) {
            return;
          }
          this.$nextTick(() => {
            let selectTrackDom = this.$el;
            if (selectTrackDom) {
              // selectTrackDom.scrollIntoView();
              // selectTrackDom.scrollIntoViewIfNeeded();  // 火狐不支持
              const parentElement = selectTrackDom.parentElement;
              if (parentElement) {
                parentElement.scrollTop += selectTrackDom.getBoundingClientRect().top - parentElement.getBoundingClientRect().top;
              }
            }
          });
        }
      }
    },
    reordering(val) {
      if (val && !this.selected) {
        const effectOrder = this.activeFragment.effects;
        this.savedEffectOrder = effectOrder.filter(eid => eid !== this.selectedEffect.id);
        this.origEffectIndex = effectOrder.indexOf(this.effect.id);
      }
    }
  }
}
</script>

<style>
.track-group {
  display: flex;
  border-bottom: 1px solid #e8e8e8;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.track-group:hover {
  background: #fafafa;
}

.track-group--selected,
.track-group--selected:hover {
  background: #e8f4ff;
  z-index: 1;
}

.track-group--transitioning {
  transition: transform 0.2s;
}

.track-group__left {
  width: 249px;
  flex-shrink: 0;
  position: relative;
  background: #f9f9f9;
  z-index: 1;
  cursor: default;
}

.track-group__left--move {
  cursor: move;
}

.track-group__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: absolute;
  top: 0;
  left: 24px;
  right: 88px;
  bottom: 0;
  height: 1.5em;
  margin: auto 0;
}

.track-group__label--indent {
  left: 40px;
}

.track-group__btn {
  position: absolute;
  width: 20px;
  height: 20px;
  line-height: 20px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  background: transparent;
  outline: none;
  text-align: center;
  font-size: 14px;
  border: 0;
  padding: 0;
}

.track-group__btn:hover,
.track-group__btn:focus {
  color: #1890ff;
}

.track-group__btn--edit {
  right: 20px;
  display: none;
}

.track-group__btn--expand {
  right: 0;
  color: rgba(0, 0, 0, 0.3);
  height: 100%;
}

.track-group__btn--expand .anticon {
  transform: scale(0.6, 0.75);
  transition: 0.2s;
}

.track-group__btn--expanded .anticon {
  transform: rotate(90deg) scale(0.6, 0.75);
}

.track-group__left:hover .track-group__btn--edit {
  display: block;
}

.track-group__btn--lock {
  right: 45px;
}

.track-group__btn--hide {
  right: 70px;
}

.track-group__btn--link {
  left: 2px;
}

.track-group:hover .track-group__left {
  background: #f6f6f6;
}

.track-group--selected .track-group__left,
.track-group--selected:hover .track-group__left {
  background: #d8e9fa;
}

.track-group__right {
  flex-shrink: 0;
  flex-grow: 1;
  position: relative;
}

.track-group__right:after {
  content: "";
  position: absolute;
  width: 1px;
  height: 100%;
  left: 0;
  top: 0;
  background: #e8e8e8;
}

.track-group__right--background {
  box-shadow: inset 1px 0 #e8e8e8;
}

.track-group__right--background:after {
  content: none;
}

.track-row {
  position: relative;
  margin-bottom: -1px;
  /* height: 30px; */
  z-index: 0;
}

.track-row__body {
  position: relative;
  height: 30px;
  transition: height 0.2s;
}

.track-row__body--background {
  background: rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 30px;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
}

.track-row__body--background .color-gradient-editor {
  margin: 0;
  display: flex;
}

.track-row__body--background .color-gradient-editor__label {
  margin-right: 8px;
  font-size: 14px;
}

.track-row__body--background .el-color-picker {
  margin-bottom: 2px;
}

.track-row__body--background .el-color-picker__trigger {
  border-color: rgba(0, 0, 0, 0.08);
}

.track-row__unset-btn {
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  width: 20px;
  height: 20px;
  border-radius: 12px;
  margin-left: 8px;
  padding: 0;
  line-height: 1;
}

.track-row__unset-btn:hover,
.track-row__unset-btn:focus {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
}

.track-row__unset-btn:active {
  color: #fff;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
